module.exports = __webpack_public_path__ + "img/settings.e01e5666.png";